export default __webpack_public_path__ + "4d68bda38339d7dda359ccf34b633847.png";